module.exports = __webpack_public_path__ + "img/Logo_conexion_pos.76ed0bc5.png";